/**
 * @desc 根据店铺编号获取仓库信息
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(
  params: API.fulfilment.warehouseFacadeImpl.getWarehouseByShop.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/warehouse/getWarehouseByShopCode`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
